export default __webpack_public_path__ + "static/media/x-mark.85bf7876.svg";